let csrfToken = null;
let tokenRequest = null;

async function getToken(refresh = false) {
    if (!refresh && csrfToken) return csrfToken;
    if (!tokenRequest) {
        tokenRequest = fetch('/api/csrf', { credentials: 'same-origin', cache: 'no-store' })
            .then(async response => {
                if (!response.ok) throw new Error('Could not load CSRF token');
                const data = await response.json();
                if (typeof data.csrf_token !== 'string' || !data.csrf_token) {
                    throw new Error('Invalid CSRF token');
                }
                csrfToken = data.csrf_token;
                return csrfToken;
            })
            .finally(() => { tokenRequest = null; });
    }
    return tokenRequest;
}

export async function csrfFetch(input, options) {
    const url = new URL(input instanceof Request ? input.url : input, window.location.href);
    if (url.origin !== window.location.origin || !url.pathname.startsWith('/api/')) {
        return fetch(input, options);
    }
    const request = new Request(input instanceof Request ? input : url, options);
    const write = !['GET', 'HEAD', 'OPTIONS'].includes(request.method.toUpperCase());
    if (write) request.headers.set('X-CSRF-Token', await getToken());

    let response = await fetch(request.clone());
    if (response.headers.has('X-CSRF-Token')) csrfToken = response.headers.get('X-CSRF-Token');
    if (write && response.status === 403 && response.headers.get('X-CSRF-Error') === '1') {
        request.headers.set('X-CSRF-Token', await getToken(true));
        response = await fetch(request.clone());
        if (response.headers.has('X-CSRF-Token')) csrfToken = response.headers.get('X-CSRF-Token');
    }
    return response;
}
